/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

interface ILabelProps {
    className: string;
    label: string;
}

const Label: React.FC<ILabelProps> = ({ className, label }) => <span className={className}>{label}</span>;

export default Label;
